// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file sidecar/v1/local_api.proto (package sidecar.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file sidecar/v1/local_api.proto.
 */
export const file_sidecar_v1_local_api: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message sidecar.v1.PingRequest
 */
export type PingRequest = Message<"sidecar.v1.PingRequest"> & {
  /**
   * @generated from field: int64 client_timestamp_ms = 1;
   */
  clientTimestampMs: bigint;
};

/**
 * Describes the message sidecar.v1.PingRequest.
 * Use `create(PingRequestSchema)` to create a new message.
 */
export const PingRequestSchema: GenMessage<PingRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_local_api, 0);

/**
 * @generated from message sidecar.v1.PingResponse
 */
export type PingResponse = Message<"sidecar.v1.PingResponse"> & {
  /**
   * @generated from field: int64 client_timestamp_ms = 1;
   */
  clientTimestampMs: bigint;

  /**
   * @generated from field: int64 server_timestamp_ms = 2;
   */
  serverTimestampMs: bigint;
};

/**
 * Describes the message sidecar.v1.PingResponse.
 * Use `create(PingResponseSchema)` to create a new message.
 */
export const PingResponseSchema: GenMessage<PingResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_local_api, 1);

/**
 * @generated from message sidecar.v1.GetSystemInfoRequest
 */
export type GetSystemInfoRequest = Message<"sidecar.v1.GetSystemInfoRequest"> & {
};

/**
 * Describes the message sidecar.v1.GetSystemInfoRequest.
 * Use `create(GetSystemInfoRequestSchema)` to create a new message.
 */
export const GetSystemInfoRequestSchema: GenMessage<GetSystemInfoRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_local_api, 2);

/**
 * @generated from message sidecar.v1.GetSystemInfoResponse
 */
export type GetSystemInfoResponse = Message<"sidecar.v1.GetSystemInfoResponse"> & {
  /**
   * @generated from field: string hostname = 1;
   */
  hostname: string;

  /**
   * @generated from field: string operating_system = 2;
   */
  operatingSystem: string;

  /**
   * @generated from field: string os_version = 3;
   */
  osVersion: string;

  /**
   * @generated from field: int64 uptime_seconds = 4;
   */
  uptimeSeconds: bigint;

  /**
   * @generated from field: double cpu_usage_percent = 5;
   */
  cpuUsagePercent: number;

  /**
   * @generated from field: int64 memory_total_bytes = 6;
   */
  memoryTotalBytes: bigint;

  /**
   * @generated from field: int64 memory_used_bytes = 7;
   */
  memoryUsedBytes: bigint;

  /**
   * @generated from field: int64 disk_total_bytes = 8;
   */
  diskTotalBytes: bigint;

  /**
   * @generated from field: int64 disk_used_bytes = 9;
   */
  diskUsedBytes: bigint;
};

/**
 * Describes the message sidecar.v1.GetSystemInfoResponse.
 * Use `create(GetSystemInfoResponseSchema)` to create a new message.
 */
export const GetSystemInfoResponseSchema: GenMessage<GetSystemInfoResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_local_api, 3);

/**
 * @generated from message sidecar.v1.GetLogsRequest
 */
export type GetLogsRequest = Message<"sidecar.v1.GetLogsRequest"> & {
  /**
   * @generated from field: int32 tail_lines = 1;
   */
  tailLines: number;
};

/**
 * Describes the message sidecar.v1.GetLogsRequest.
 * Use `create(GetLogsRequestSchema)` to create a new message.
 */
export const GetLogsRequestSchema: GenMessage<GetLogsRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_local_api, 4);

/**
 * @generated from message sidecar.v1.GetLogsResponse
 */
export type GetLogsResponse = Message<"sidecar.v1.GetLogsResponse"> & {
  /**
   * @generated from field: string content = 1;
   */
  content: string;
};

/**
 * Describes the message sidecar.v1.GetLogsResponse.
 * Use `create(GetLogsResponseSchema)` to create a new message.
 */
export const GetLogsResponseSchema: GenMessage<GetLogsResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_local_api, 5);

/**
 * @generated from message sidecar.v1.WipeLogsRequest
 */
export type WipeLogsRequest = Message<"sidecar.v1.WipeLogsRequest"> & {
};

/**
 * Describes the message sidecar.v1.WipeLogsRequest.
 * Use `create(WipeLogsRequestSchema)` to create a new message.
 */
export const WipeLogsRequestSchema: GenMessage<WipeLogsRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_local_api, 6);

/**
 * @generated from message sidecar.v1.WipeLogsResponse
 */
export type WipeLogsResponse = Message<"sidecar.v1.WipeLogsResponse"> & {
};

/**
 * Describes the message sidecar.v1.WipeLogsResponse.
 * Use `create(WipeLogsResponseSchema)` to create a new message.
 */
export const WipeLogsResponseSchema: GenMessage<WipeLogsResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_local_api, 7);

/**
 * @generated from message sidecar.v1.ListQueueEntriesRequest
 */
export type ListQueueEntriesRequest = Message<"sidecar.v1.ListQueueEntriesRequest"> & {
};

/**
 * Describes the message sidecar.v1.ListQueueEntriesRequest.
 * Use `create(ListQueueEntriesRequestSchema)` to create a new message.
 */
export const ListQueueEntriesRequestSchema: GenMessage<ListQueueEntriesRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_local_api, 8);

/**
 * @generated from message sidecar.v1.QueueEntry
 */
export type QueueEntry = Message<"sidecar.v1.QueueEntry"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string file_id = 2;
   */
  fileId: string;

  /**
   * @generated from field: string camera_unique_id = 3;
   */
  cameraUniqueId: string;

  /**
   * @generated from field: string storage_key = 4;
   */
  storageKey: string;

  /**
   * @generated from field: string content_type = 5;
   */
  contentType: string;

  /**
   * @generated from field: int64 file_size = 6;
   */
  fileSize: bigint;

  /**
   * @generated from field: string enqueued_at = 7;
   */
  enqueuedAt: string;
};

/**
 * Describes the message sidecar.v1.QueueEntry.
 * Use `create(QueueEntrySchema)` to create a new message.
 */
export const QueueEntrySchema: GenMessage<QueueEntry> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_local_api, 9);

/**
 * @generated from message sidecar.v1.ListQueueEntriesResponse
 */
export type ListQueueEntriesResponse = Message<"sidecar.v1.ListQueueEntriesResponse"> & {
  /**
   * @generated from field: repeated sidecar.v1.QueueEntry entries = 1;
   */
  entries: QueueEntry[];
};

/**
 * Describes the message sidecar.v1.ListQueueEntriesResponse.
 * Use `create(ListQueueEntriesResponseSchema)` to create a new message.
 */
export const ListQueueEntriesResponseSchema: GenMessage<ListQueueEntriesResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_local_api, 10);

/**
 * @generated from message sidecar.v1.DeleteQueueEntryRequest
 */
export type DeleteQueueEntryRequest = Message<"sidecar.v1.DeleteQueueEntryRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sidecar.v1.DeleteQueueEntryRequest.
 * Use `create(DeleteQueueEntryRequestSchema)` to create a new message.
 */
export const DeleteQueueEntryRequestSchema: GenMessage<DeleteQueueEntryRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_local_api, 11);

/**
 * @generated from message sidecar.v1.DeleteQueueEntryResponse
 */
export type DeleteQueueEntryResponse = Message<"sidecar.v1.DeleteQueueEntryResponse"> & {
};

/**
 * Describes the message sidecar.v1.DeleteQueueEntryResponse.
 * Use `create(DeleteQueueEntryResponseSchema)` to create a new message.
 */
export const DeleteQueueEntryResponseSchema: GenMessage<DeleteQueueEntryResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_local_api, 12);

/**
 * @generated from message sidecar.v1.RunDiscoveryRequest
 */
export type RunDiscoveryRequest = Message<"sidecar.v1.RunDiscoveryRequest"> & {
  /**
   * @generated from field: sidecar.v1.DeviceType device_type = 1;
   */
  deviceType: DeviceType;
};

/**
 * Describes the message sidecar.v1.RunDiscoveryRequest.
 * Use `create(RunDiscoveryRequestSchema)` to create a new message.
 */
export const RunDiscoveryRequestSchema: GenMessage<RunDiscoveryRequest> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_local_api, 13);

/**
 * @generated from message sidecar.v1.RunDiscoveryResponse
 */
export type RunDiscoveryResponse = Message<"sidecar.v1.RunDiscoveryResponse"> & {
  /**
   * @generated from field: sidecar.v1.DeviceType device_type = 1;
   */
  deviceType: DeviceType;

  /**
   * @generated from field: string phase = 2;
   */
  phase: string;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * Describes the message sidecar.v1.RunDiscoveryResponse.
 * Use `create(RunDiscoveryResponseSchema)` to create a new message.
 */
export const RunDiscoveryResponseSchema: GenMessage<RunDiscoveryResponse> = /*@__PURE__*/
  messageDesc(file_sidecar_v1_local_api, 14);

/**
 * @generated from enum sidecar.v1.DeviceType
 */
export enum DeviceType {
  /**
   * @generated from enum value: DEVICE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEVICE_TYPE_CAMERAS = 1;
   */
  CAMERAS = 1,

  /**
   * @generated from enum value: DEVICE_TYPE_SCANNERS = 2;
   */
  SCANNERS = 2,

  /**
   * @generated from enum value: DEVICE_TYPE_PRINTERS = 3;
   */
  PRINTERS = 3,

  /**
   * @generated from enum value: DEVICE_TYPE_SCALES = 4;
   */
  SCALES = 4,
}

/**
 * Describes the enum sidecar.v1.DeviceType.
 */
export const DeviceTypeSchema: GenEnum<DeviceType> = /*@__PURE__*/
  enumDesc(file_sidecar_v1_local_api, 0);

/**
 * @generated from service sidecar.v1.SidecarLocalService
 */
export const SidecarLocalService: GenService<{
  /**
   * @generated from rpc sidecar.v1.SidecarLocalService.Ping
   */
  ping: {
    methodKind: "unary";
    input: typeof PingRequestSchema;
    output: typeof PingResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.SidecarLocalService.GetSystemInfo
   */
  getSystemInfo: {
    methodKind: "unary";
    input: typeof GetSystemInfoRequestSchema;
    output: typeof GetSystemInfoResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.SidecarLocalService.GetLogs
   */
  getLogs: {
    methodKind: "server_streaming";
    input: typeof GetLogsRequestSchema;
    output: typeof GetLogsResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.SidecarLocalService.WipeLogs
   */
  wipeLogs: {
    methodKind: "unary";
    input: typeof WipeLogsRequestSchema;
    output: typeof WipeLogsResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.SidecarLocalService.ListQueueEntries
   */
  listQueueEntries: {
    methodKind: "unary";
    input: typeof ListQueueEntriesRequestSchema;
    output: typeof ListQueueEntriesResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.SidecarLocalService.DeleteQueueEntry
   */
  deleteQueueEntry: {
    methodKind: "unary";
    input: typeof DeleteQueueEntryRequestSchema;
    output: typeof DeleteQueueEntryResponseSchema;
  },
  /**
   * @generated from rpc sidecar.v1.SidecarLocalService.RunDiscovery
   */
  runDiscovery: {
    methodKind: "server_streaming";
    input: typeof RunDiscoveryRequestSchema;
    output: typeof RunDiscoveryResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_sidecar_v1_local_api, 0);

